import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Layout from '../../components/global/layout';
import ApiClient from '../../methods/api/apiClient';
import loader from '../../methods/loader';
import './profile.scss'
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import methodModel from '../../methods/methods';
import PhoneInput from 'react-phone-input-2';


const Profile = () => {
  const history = useNavigate();

  const user = useSelector((state: any) => state.user);
  const [data, setData]: any = useState('');

  const gallaryData = () => {
    loader(true)
    ApiClient.get(`admin/profile`, { id: user?.id || user._id }).then(res => {
      if (res.success) {
        setData(res.data)
      }
      loader(false)

    })
  };

  const back = () => {
    history('/dashboard');
  };

  useEffect(
    () => {
      if (user && user.loggedIn) {
        gallaryData();
      }
    },
    []
  );

  return (
    <Layout>


      <div className='wrapper_section'>
        <div className='flex items-center  justify-between am:col-span-12 md:col-span-4 p-4 shadow-box rounded-lg bg-white'>

          <div className='flex items-center'>
            {/* <button onClick={back} type="button" className="!px-4 bg-[#fff] py-2 flex items-center justify-center  rounded-lg shadow-btn hover:bg-[#F3F2F5] border  transition-all mr-3"><i className="fa fa-angle-left text-lg" ></i></button> */}
            <div>
              <h3 className="text-2xl font-semibold text-[#111827]">Profile</h3>
            </div>
          </div>
          <Link to="/profile/edit" className="!px-4 text-sm font-normal bg-[#A12238] text-white h-10 flex items-center justify-center gap-2 !bg-primary rounded-lg shadow-btn hover:opacity-80 transition-all focus:ring-2 ring-[#EDEBFC] disabled:bg-[#D0CAF6] disabled:cursor-not-allowed">

            <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0z"></path><path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04a.996.996 0 000-1.41l-2.34-2.34a.996.996 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"></path></svg>
            Edit Profile

          </Link>
        </div>

        <div className='inner_part mt-5 '>
          <div className='grid grid-cols-12 gap-4'>
            <div className='col-span-12 md:col-span-4 p-6 shadow-box overflow-hidden rounded-lg bg-white'>
              {/* <label className='text-typo text-base font-medium max-w-sm w-full block' >Image</label> */}
              <div className='flex items-center justify-center h-[100%]'>
                <div className='imagethumbWrapper'>
                  <img src={methodModel.userImg(data && data.image)} className="h-[200px] w-[200px] mx-auto rounded-full object-cover p-1 shadow-md" />
                </div>
              </div>
            </div>

            <div className='col-span-12 md:col-span-8 p-6 shadow-box overflow-hidden rounded-lg bg-white'>
              <div className='mb-3'>
                <label className='text-typo text-base font-medium max-w-sm w-full block'>Name</label>
                <div className='sub_fatch'>
                  <p className='profiledetailscls bg-[#f5f5f5] px-[10px] py-[8px] min-h-[38px] rounded-md capitalize'>{data && data.fullName}</p>
                </div>
              </div>

              <div className='mb-3'>
                <label className='text-typo text-base font-medium max-w-sm w-full block'>Email</label>
                <div className='sub_fatch'>
                  <p className='profiledetailscls bg-[#f5f5f5] px-[10px] py-[8px] min-h-[38px] rounded-md' >{data && data.email}</p>
                </div>
              </div>

              <div className='mb-3'>
                <label className='text-typo text-base font-medium max-w-sm w-full block'>Mobile No.</label>
                <div className='sub_fatch'>
                  <PhoneInput
                    country={'us'}
                    value={data?.dialCode + data?.mobileNo || ''}
                    // minLength={10}

                    disabled

                  />
                  {/* <p className='profiledetailscls bg-[#f5f5f5] px-[10px] py-[8px] min-h-[38px] rounded-md'>{String(data.dialCode ? '+' + data.dialCode + " " + data.mobileNo : '')}</p> */}
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>



    </Layout>
  );
};

export default Profile;
